var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chipCount > 0)?_c('div',_vm._l((_vm.chipCount),function(index){return _c('div',{key:index,class:['chip', 'denomination-' + _vm.denomination],style:({ top: _vm.nextChipTopPosition(index) + 'px' })})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }